import { useState, type FC } from "react";
import TextLinkButton from "../../atoms/buttons/TextLinkButton";
import Modal from "../Modal";
import { theme } from "../../../theme";
import type { CommentModel } from "../../../models/CommentModel";
import { Row } from "react-grid-system";
import Subtitle from "../../atoms/typography/Subtitle";
import { HorizontalSpacer } from "../../atoms/Spacers";
import styled from "styled-components";
import BodySmall from "../../atoms/typography/BodySmall";
import Body from "../../atoms/typography/Body";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

export interface NotesDisplayModel {
  comments?: Array<CommentModel>;
  totalCount: number;
  fileName: string;
}

interface Props {
  notes: Array<NotesDisplayModel>;
}

const NotesContainer = styled.div`
  margin: 8px 0px;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid ${theme.colors.grey05};
`;

const DisplayUploadUnitNotesButton: FC<Props> = ({ notes }) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);

  const numberOfComments = notes.reduce(
    (acc, note) => acc + (note.comments ? note.comments.length : 0),
    0,
  );

  if (numberOfComments === 0) {
    return null;
  }

  return (
    <div>
      <TextLinkButton
        title={`${t(
          "documentHandler.displayNotifications",
        )} (${numberOfComments}st)`}
        onClick={() => setModalOpen(true)}
        color={theme.colors.primary}
      />
      {modalOpen && (
        <Modal onClose={() => setModalOpen(false)} closeIcon width={400}>
          <Row justify="center">
            <Subtitle color={theme.colors.primary}>
              {t("documentHandler.notifications")}
            </Subtitle>
          </Row>
          <HorizontalSpacer spacing={1} />
          {notes.map((note) => (
            <NotesContainer key={note.fileName}>
              <BodySmall color={theme.colors.textSecondary}>
                {note.fileName}
              </BodySmall>
              <HorizontalSpacer spacing={0.5} />
              {note.comments && note.comments.length > 0 ? (
                note.comments.map((comment) => (
                  <div key={comment.id}>
                    <BodySmall color={theme.colors.textMuted}>
                      {comment.createdByUser?.firstName}{" "}
                      {comment.createdByUser?.lastName} -{" "}
                      {dayjs(comment.createdAt).format("YYYY-MM-DD HH:mm")}
                    </BodySmall>
                    <Body>{comment.content}</Body>
                    <HorizontalSpacer spacing={0.5} />
                  </div>
                ))
              ) : (
                <BodySmall>
                  {t("documentHandler.noNotificationsForThisFile")}
                </BodySmall>
              )}
            </NotesContainer>
          ))}
        </Modal>
      )}
    </div>
  );
};

export default DisplayUploadUnitNotesButton;
